import { SText } from '@setvi/shared/components';
import { Product } from '@setvi/shared/interfaces';

interface SizeProps {
  product: Product;
}

export const Size = ({ product }: SizeProps) => {
  // @ts-ignore
  const size = product?.custom?.size;
  // @ts-ignore
  const sizeCm = product?.custom?.sizeCm;

  return (
    <SText title={size ? `${size}${sizeCm ? `, ${sizeCm}cm` : ''}` : '-'} />
  );
};
